var exports = {
  "container": "x234b8571--20720c--container",
  "red": "x234b8571--20720c--red",
  "green": "x234b8571--20720c--green",
  "header": "x234b8571--20720c--header",
  "main": "x234b8571--20720c--main",
  "section--header": "x234b8571--20720c--section--header",
};

module.exports = exports;
